import WarehouseMainPage from '@/modules/warehouse/views/pages/main/registrant.vue';
import UploadInvoicesPage from '@/modules/warehouse/views/pages/uploadInvoices/index.vue';
import ViewBatchRecordPage from '@/modules/warehouse/views/pages/viewBatchRecord/index.vue';
import ViewWarehousePage from '@/modules/warehouse/views/pages/viewWarehouse/index.vue';
import ViewFactoryPage from '@/modules/warehouse/views/pages/viewFactory/index.vue';
import WarehouseListPage from '@/modules/warehouse/views/pages/companyWarehouseList/companyWarehouseList.vue';
import WarehouseBatchRegistrationPage from '@/modules/warehouse/views/pages/uploadWarehouses/index.vue';
import CompanyWarehouseRegistrationPage from '@/modules/warehouse//views/pages/companyWarehouseRegistration/companyWarehouseRegistration.vue';
import ViewInboundInvoicesPage from '@/modules/warehouse/views/pages/viewInboundInvoices/index.vue';
import ImportInboundResultsPage from '@/modules/warehouse/views/pages/importInboundResults/index.vue';

const routes = [
    {
        path: '/armazem/saldo',
        name: 'saldoArmazem',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: WarehouseMainPage
    },
    {
        path: '/armazem/upload-notas-lote/:action',
        name: 'UploadNotasLote',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: UploadInvoicesPage
    },
    {
        path: '/armazem/processamento-lote/',
        name: 'ProcessamentoNotasLote',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: ViewBatchRecordPage
    },
    {
        path: '/armazem/visualizar-armazem/:viewPendingOperations',
        name: 'VisualizarArmazem',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: ViewWarehousePage
    },
    {
        path: '/armazem/visualizar-fabrica/:viewPendingOperations',
        name: 'VisualizarFabrica',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: ViewFactoryPage
    },
    {
        path: '/porto/visualizar-porto/:viewPendingOperations',
        name: 'VisualizarPorto',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: ViewWarehousePage
    },
    {
        path: '/armazem',
        name: 'ListaArmazem',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: WarehouseListPage
    },
    {
        path: '/armazem/cadastrar-armazem/:action',
        name: 'CadastrarArmazem',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: WarehouseBatchRegistrationPage
    },
    {
        path: '/armazem/notas-entrada',
        name: 'NotasEntrada',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: ViewInboundInvoicesPage
    },
    {
        path: '/armazem/notas-entrada/importar-resultados',
        name: 'ImportarResultadosNotasEntrada',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: ImportInboundResultsPage
    },
    {
        path: '/armazem/acompanhar-cadastro',
        name: 'AcompanharCadastroArmazem',
        meta: {
            roles: [
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_CADASTRANTE',
                'ROLE_FEATURE_CONTRATO_RASTREABILIDADE_APROVADOR'
            ]
        },
        component: CompanyWarehouseRegistrationPage
    }
];

export default routes;
